import { Tag, TreeEvergreen, Car, Heart, ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

/**
 * "At-a-glance" strip that replaces the booking widget on the Home page hero.
 * Since RMS Cloud handles the booking form itself (and pre-fills nothing we
 * couldn't defer), this strip trades a form for four confidence cues + a
 * single strong CTA into the RMS engine.
 */
const STATS = [
  {
    icon: Tag,
    label: "From $35 / night",
    sub: "Best rate direct",
    testid: "stat-price",
  },
  {
    icon: TreeEvergreen,
    label: "Twelve acres",
    sub: "of native bushland",
    testid: "stat-acres",
  },
  {
    icon: Car,
    label: "90 min · Melbourne",
    sub: "15 min to town centre",
    testid: "stat-distance",
  },
  {
    icon: Heart,
    label: "Family-owned",
    sub: "and pet-friendly",
    testid: "stat-family",
  },
];

export default function HeroStatsStrip({ overlap = true }) {
  return (
    <div
      className={`bg-white rounded-2xl shadow-[0_20px_60px_-20px_rgba(38,45,40,0.35)] ${
        overlap ? "relative -mt-20 md:-mt-24 z-10" : ""
      }`}
      data-testid="hero-stats-strip"
    >
      <div className="grid grid-cols-2 md:grid-cols-5 gap-0 divide-y md:divide-y-0 md:divide-x divide-sa-ink/10">
        {STATS.map((s) => {
          const Icon = s.icon;
          return (
            <div
              key={s.testid}
              className="px-6 py-5 md:py-7 flex items-center gap-4"
              data-testid={s.testid}
            >
              <Icon size={28} weight="duotone" className="text-sa-accent shrink-0" />
              <div className="min-w-0">
                <div className="font-serif text-base md:text-lg leading-tight text-sa-ink">
                  {s.label}
                </div>
                <div className="text-xs text-sa-ink2 mt-0.5">{s.sub}</div>
              </div>
            </div>
          );
        })}
        <div className="col-span-2 md:col-span-1 p-4 md:p-5 flex items-center justify-center">
          <Link
            to="/book"
            data-testid="hero-strip-book-btn"
            className="group w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-sa-accent hover:bg-sa-accentHover text-white text-sm font-medium transition-colors whitespace-nowrap"
          >
            Book direct
            <ArrowRight size={16} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </div>
  );
}
